import axios from "axios";

// Assuming you have a headers function similar to getHeaders in your example
// If not, you can modify this function or remove the getHeaders() call
const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
  };
};

export const getInterestedDomainPieChart = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/post_services/interested_domain_pie_charts/`,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch interested domain data"
    );
  }
};
